import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * PWA install banner for admin panel.
 * Listens for beforeinstallprompt event, shows a compact bottom banner
 * with "Install App" button. Dismissible for the session.
 * Only visible on /admin/* routes.
 */
export default function AdminInstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Already installed (standalone display mode) → nothing to show
    if (typeof window === "undefined") return;
    if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) return;
    if (sessionStorage.getItem("reddy_admin_install_dismissed") === "1") {
      setDismissed(true);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!prompt || dismissed) return null;

  const install = async () => {
    try {
      prompt.prompt();
      const { outcome } = await prompt.userChoice;
      if (outcome === "accepted") {
        setDismissed(true);
      }
    } catch (_) {}
    setPrompt(null);
  };

  const skip = () => {
    sessionStorage.setItem("reddy_admin_install_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="admin-pwa-banner"
      className="fixed bottom-3 left-3 right-3 z-40 rounded-2xl shadow-2xl p-3 flex items-center gap-3"
      style={{
        background: "linear-gradient(135deg, #0c1e5e 0%, #1e40af 100%)",
        boxShadow: "0 15px 40px -10px rgba(12, 30, 94, 0.55)",
        animation: "slideUp 400ms cubic-bezier(0.34, 1.56, 0.64, 1)",
      }}
    >
      <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center flex-shrink-0">
        <Download className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0 text-white">
        <div className="font-bold text-sm">Install Reddy Admin</div>
        <div className="text-[11px] text-white/80 truncate">Ek tap me phone pe app add karo</div>
      </div>
      <button
        onClick={install}
        data-testid="admin-pwa-install-btn"
        className="px-4 py-2 rounded-xl bg-amber-400 text-blue-950 text-sm font-bold whitespace-nowrap active:scale-95 transition-transform"
      >
        Install
      </button>
      <button
        onClick={skip}
        aria-label="Dismiss"
        className="w-8 h-8 rounded-lg text-white/70 hover:text-white hover:bg-white/10 flex items-center justify-center"
      >
        <X className="w-4 h-4" />
      </button>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
